import { render, staticRenderFns } from "./TagDeleteDialog.vue?vue&type=template&id=ccc2ba34&scoped=true"
import script from "./TagDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./TagDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./TagDeleteDialog.vue?vue&type=style&index=0&id=ccc2ba34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc2ba34",
  null
  
)

export default component.exports